import Loader from "components/shared/loader";
import React from "react";

const ChatLoader = ({ endReached, isLoading }) => {
    if (endReached) {
        return null;
    }
    return <div className="chat__loader">{isLoading && <Loader prefix="chat-loader" />}</div>;
};

export default ChatLoader;
